import React, { useRef, useEffect, useMemo, useCallback, useState } from 'react';
import PropTypes from "prop-types";
import { withRouter } from "tools/routerCompat";
import { Link as RouterLink } from "react-router-dom";
import Link from "@mui/material/Link";
import { reduxForm, Field } from 'redux-form';
import Button from "@mui/material/Button";
import { InputField } from 'components/FormElements';
import { stripSearchParam } from 'components/Shared/Formatters';
import { validateResetPassword as validate, passwordValidation } from 'validations';
import {
  resetPassword as resetPasswordRequest,
  getPasswordDefinitions as getPasswordDefinitionsRequest
} from 'requests/profile';
import logo from 'static/images/logo.png';

const ResetPassword = ({
  history: {
    push,
    location: {
      search,
    }
  },
  handleSubmit,
  invalid,
  pristine,
  submitting
}) => {
  const mounted = useRef(true);
  const [passwordDefinitions, setPasswordDefinitions] = useState({
    specialCharacters: '',
    minPasswordLength: 8,
  });
  const onPasswordReset = useCallback(
    () => push('/'),
    []
  );
  const resetPassword = useCallback(
    password => resetPasswordRequest(
      {
        password,
        token,
      },
      onPasswordReset,
      mounted
    ),
    [token, mounted]
  );
  useEffect(
    () => {
      getPasswordDefinitionsRequest(
        setPasswordDefinitions,
        mounted
      );
      return () => mounted.current = false;
    },
    []
  );
  const token = useMemo(
    () => stripSearchParam(search),
    [search]
  );

  const onSubmit = useCallback(
    ({ password }) => resetPassword(password),
    [resetPassword]
  );

  return (
    <div className="md-grid md-cell login-wrapper">
      <div className="login-form">
        <img src={logo} alt="logo.png" className="mueller-logo" />
        <h3 className="mueller-title" data-test="title">Access Mueller Reports</h3>
        <form onSubmit={handleSubmit(onSubmit)}>
          <Field
            id="password"
            name="password"
            component={InputField}
            type="password"
            hintText="New Password"
            dataTest="password"
            validate={passwordValidation(passwordDefinitions)}
            tabIndex={1}
          />
          <Field
            id="confirmation"
            name="confirmation"
            component={InputField}
            type="password"
            hintText="Confirm New Password"
            dataTest="confirmation"
            tabIndex={2}
          />
          <Button
            type="submit"
            className="full-width m-t-10"
            disabled={invalid || pristine || submitting}
            data-test="reset-password"
            tabIndex={3}
          >SET NEW PASSWORD</Button>
          <Link component={RouterLink} to="/login" className="link" data-test="back-to-login">
            BACK TO LOGIN
          </Link>
        </form>
      </div>
    </div>
  );
};

ResetPassword.propTypes = {
  history: PropTypes.object,
  handleSubmit: PropTypes.func,
  invalid: PropTypes.bool,
  pristine: PropTypes.bool,
  submitting: PropTypes.bool,
};

export default withRouter(reduxForm({
  form: 'ResetPassword',
  validate,
})(ResetPassword));